import { Bold } from '@tiptap/extension-bold';
import { Document } from '@tiptap/extension-document';
import { HardBreak } from '@tiptap/extension-hard-break';
import { Italic } from '@tiptap/extension-italic';
import { Paragraph } from '@tiptap/extension-paragraph';
import { Text } from '@tiptap/extension-text';
import { Underline } from '@tiptap/extension-underline';

// Base schema shared by every rich-text field (useRichTextField, useNoteEditor, noteEditor.utils).
export const RICH_TEXT_EXTENSIONS = [Document, Paragraph, Text, Bold, Italic, Underline, HardBreak];
